import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { CommandsService } from 'src/app/core/services/command.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import {
  BatchCommandFilter,
  BatchCommandListItem,
  BatchCommandRequest,
  BatchCommandSchedule,
  BatchCommandScheduleDay,
  BatchCommandTargetType,
  BatchCommandDetailResponse,
  CommandinfoType,
  CommandSelect,
  CommandToSend,
  Timeout,
} from 'src/app/core/models/commands.model';

@Component({
  selector: 'app-batch-commands',
  templateUrl: './batch-commands.component.html',
  styleUrls: ['./batch-commands.component.scss'],
})
export class BatchCommandsComponent implements OnInit, OnDestroy {
  constructor(
    private commandsService: CommandsService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private toastService: ToastService,
    private authService: AuthService
  ) {}

  nomeComando: string = '';
  comandoSelecionadoNome: string = '';
  comandoSelecionadoJson: CommandToSend | null = null;
  envioPara: 'seriais' | 'equipamento' = 'seriais';
  seriais: string = '';
  equipamentoSelecionado: string | null = null;
  equipamentos: string[] = [];
  carregandoEquipamentos: boolean = false;
  firmwareSelecionado: string | null = null;
  firmwares: string[] = [];
  carregandoFirmwares: boolean = false;

  agendamentoTipo: 'qualquerMomento' | 'especifico' = 'qualquerMomento';
  agendamentos: BatchCommandSchedule[] = [];
  erroAgendamento: string = '';
  novoAgendamentoDia: BatchCommandScheduleDay | null = null;
  novoAgendamentoHoraInicio: string = '';
  novoAgendamentoHoraFim: string = '';
  readonly diasSemanaOptions: { value: BatchCommandScheduleDay; label: string }[] = [
    { value: 'SEGUNDA', label: 'Segunda-feira' },
    { value: 'TERCA', label: 'Terça-feira' },
    { value: 'QUARTA', label: 'Quarta-feira' },
    { value: 'QUINTA', label: 'Quinta-feira' },
    { value: 'SEXTA', label: 'Sexta-feira' },
    { value: 'SABADO', label: 'Sábado' },
    { value: 'DOMINGO', label: 'Domingo' },
  ];

  salvando: boolean = false;
  mensagemErro: string = '';

  batchCommands: BatchCommandListItem[] = [];
  carregandoLista: boolean = false;
  filtroDataInicial: string = '';
  filtroDataFinal: string = '';
  filtroNome: string = '';
  filtroIdComando: number = -1;
  filtroStatus: string = '';
  filtroSerial: string = '';
  filtroErro: string = '';
  readonly statusOptions: string[] = ['PENDENTE', 'ENVIANDO', 'EXECUTADO', 'CANCELADO'];

  // paginação do retorno de comandos em lote (total, size, page, hasNext)
  paginaAtual: number = 1;
  tamanhoPagina: number = 50;
  totalRegistros: number = 0;
  totalPaginas: number = 0;
  temProximaPagina: boolean = false;

  commandInfoType: CommandinfoType[] = [];
  commandModalSelect: CommandSelect = this.criarCommandModalSelect();

  detalheSelecionado: BatchCommandListItem | null = null;
  private readonly statusPermitemCancelar = ['PENDENTE', 'ENVIANDO'];

  detalheComando: BatchCommandDetailResponse | null = null;
  carregandoDetalhe: boolean = false;
  erroDetalhe: string = '';
  paginaSeriais: number = 1;
  tamanhoPaginaSeriais: number = 100;
  totalPaginasSeriais: number = 0;

  // timer de atualização automática da lista de comandos em lote enviados
  readonly intervalosAtualizacao: { label: string; segundos: number }[] = [
    { label: '5m', segundos: 5 * 60 },
    { label: '1m', segundos: 60 },
    { label: '30s', segundos: 30 },
    { label: '10s', segundos: 10 },
  ];
  intervaloAtualizacaoSegundos: number = this.intervalosAtualizacao[0].segundos;
  segundosRestantesAtualizacao: number = this.intervaloAtualizacaoSegundos;
  timerAtualizacaoAtivo: boolean = true;
  private timerAtualizacaoId: any = null;

  timeOutKeys: any = Object.values(Timeout).slice(
    0,
    Object.keys(Timeout).length / 2
  );
  timeOutValues: any = Object.values(Timeout).slice(
    Object.keys(Timeout).length / 2,
    Object.keys(Timeout).length
  );

  ngOnInit(): void {
    this.filtrar();
    this.loadCommandInfoType();
    this.iniciarTimerAtualizacao();
  }

  ngOnDestroy(): void {
    this.pararTimerAtualizacao();
  }

  // dispara um tick a cada 1s, decrementando o contador até zerar e então refaz a busca (mesma lógica do botão "Filtrar")
  private iniciarTimerAtualizacao(): void {
    this.pararTimerAtualizacao();
    this.timerAtualizacaoId = setInterval(() => {
      this.segundosRestantesAtualizacao -= 1;
      if (this.segundosRestantesAtualizacao <= 0) {
        this.segundosRestantesAtualizacao = this.intervaloAtualizacaoSegundos;
        this.filtrar(this.paginaAtual);
      }
    }, 1000);
  }

  private pararTimerAtualizacao(): void {
    if (this.timerAtualizacaoId) {
      clearInterval(this.timerAtualizacaoId);
      this.timerAtualizacaoId = null;
    }
  }

  get tempoRestanteAtualizacaoFormatado(): string {
    const minutos = Math.floor(this.segundosRestantesAtualizacao / 60);
    const segundos = this.segundosRestantesAtualizacao % 60;
    return `${minutos.toString().padStart(2, '0')}:${segundos
      .toString()
      .padStart(2, '0')}`;
  }

  selecionarIntervaloAtualizacao(segundos: number): void {
    this.intervaloAtualizacaoSegundos = segundos;
    this.segundosRestantesAtualizacao = segundos;
  }

  alternarTimerAtualizacao(): void {
    this.timerAtualizacaoAtivo = !this.timerAtualizacaoAtivo;
    if (this.timerAtualizacaoAtivo) {
      this.iniciarTimerAtualizacao();
    } else {
      this.pararTimerAtualizacao();
    }
  }

  atualizarListaAgora(): void {
    this.segundosRestantesAtualizacao = this.intervaloAtualizacaoSegundos;
    this.filtrar(this.paginaAtual);
  }

  private criarCommandModalSelect(): CommandSelect {
    return {
      id: -1,
      comandoId: -1,
      nome: 'Selecione um comando',
      dispositivoModeloId: -1,
      dispositivoModelo: '',
      observacaoHTML: '',
      exemplo: '',
      valor: false,
      canalEnvio: '',
      param: '',
      seriais: '',
      timeout: '0',
      ambiente: '',
      paramAux: '',
    };
  }

  // mesma lógica de agrupamento por comando usada em commands.component.ts
  loadCommandInfoType(): void {
    this.commandsService.getCommandsInfoType().subscribe((response: any) => {
      if (response == null) {
        return;
      }
      this.commandInfoType = [];
      response.forEach((item: CommandinfoType) => {
        const index = this.commandInfoType.findIndex(
          (item2) => item2.comandoId == item.comandoId
        );

        if (index == -1) {
          if (item.observacaoHTML != null && item.observacaoHTML != '') {
            item.observacaoHTML = `<p>${
              item.dispositivoModelo != undefined && item.dispositivoModelo != null
                ? item.dispositivoModelo + ' → '
                : ''
            }${item.observacaoHTML}</p>`;
          }
          this.commandInfoType.push(item);
        } else if (item.observacaoHTML != null && item.observacaoHTML != '') {
          const aux = this.commandInfoType[index].observacaoHTML.split(' → ');
          if (
            aux[aux.length - 1].substring(0, aux[aux.length - 1].length - 4) ==
            item.observacaoHTML
          ) {
            if (this.commandInfoType[index].observacaoHTML.substring(0, 3) == '<p>') {
              this.commandInfoType[index].observacaoHTML =
                this.commandInfoType[index].observacaoHTML.substring(
                  3,
                  this.commandInfoType[index].observacaoHTML.length
                );
            }
            this.commandInfoType[index].observacaoHTML = `<p>${item.dispositivoModelo}, ${this.commandInfoType[index].observacaoHTML}`;
          } else {
            this.commandInfoType[index].observacaoHTML = `${
              this.commandInfoType[index].observacaoHTML
            }<p>${
              item.dispositivoModelo != undefined && item.dispositivoModelo != null
                ? item.dispositivoModelo + ' → '
                : ''
            }${item.observacaoHTML}</p>`;
          }
        }
      });
    });
  }

  filterCommandModal(command: any): void {
    let commandAux = '';
    try {
      commandAux = command['$ngOptionLabel'].trim();
    } catch (error) {}

    const commandoSelectAux = this.commandInfoType.filter(
      (item) => item.nome == commandAux
    );

    this.commandModalSelect.comandoId = -1;
    this.commandModalSelect.nome = commandAux;
    this.commandModalSelect.observacaoHTML = '';
    this.commandModalSelect.exemplo = '';
    this.commandModalSelect.valor = false;
    this.commandModalSelect.param = '';

    if (
      commandoSelectAux.length > 0 &&
      commandoSelectAux[0].observacaoHTML != undefined &&
      commandoSelectAux[0].observacaoHTML != null &&
      commandoSelectAux[0].observacaoHTML != ''
    ) {
      this.commandModalSelect.observacaoHTML = this.sanitizer.bypassSecurityTrustHtml(
        commandoSelectAux[0].observacaoHTML
      ) as string;
    }

    try {
      this.commandModalSelect.comandoId = commandoSelectAux[0].comandoId;
      this.commandModalSelect.valor = commandoSelectAux[0].valor ?? false;
      if (
        commandoSelectAux[0].exemplo != undefined &&
        commandoSelectAux[0].exemplo != null &&
        commandoSelectAux[0].exemplo != ''
      ) {
        this.commandModalSelect.exemplo = commandoSelectAux[0].exemplo;
      }
    } catch (error) {}
  }

  abrirModalNovoComando(template: any): void {
    this.commandModalSelect = this.criarCommandModalSelect();
    this.modalService.open(template, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  incluirComando(modal: any): void {
    const comando = new CommandToSend();
    comando.tipo = this.commandModalSelect.comandoId;
    comando.sistema = 'logan-lote';
    comando.param = this.commandModalSelect.valor && this.commandModalSelect.param
        ? this.commandModalSelect.param.trim()
        : undefined;
    comando.timeout = this.timeOutValues[this.commandModalSelect.timeout];

    this.comandoSelecionadoNome = this.commandModalSelect.nome;
    this.comandoSelecionadoJson = comando;

    modal.close();
  }

  selecionarEnvioPara(tipo: 'seriais' | 'equipamento'): void {
    this.envioPara = tipo;
    if (tipo === 'equipamento' && this.equipamentos.length === 0) {
      this.loadEquipamentos();
    }
  }

  loadEquipamentos(): void {
    this.carregandoEquipamentos = true;
    this.commandsService.getBatchCommandDevices().subscribe({
      next: (devices) => {
        this.equipamentos = (devices ?? []).map((device) => device.nome);
        this.carregandoEquipamentos = false;
      },
      error: () => {
        this.equipamentos = [];
        this.carregandoEquipamentos = false;
      },
    });
  }

  onEquipamentoChange(equipamento: string | null): void {
    this.equipamentoSelecionado = equipamento;
    this.firmwareSelecionado = null;
    this.firmwares = [];

    if (!equipamento) {
      return;
    }

    this.carregandoFirmwares = true;
    this.commandsService.getBatchCommandFirmwares(equipamento).subscribe({
      next: (firmwares) => {
        this.firmwares = (firmwares ?? []).map((firmware) => firmware.nome);
        this.carregandoFirmwares = false;
      },
      error: () => {
        this.firmwares = [];
        this.carregandoFirmwares = false;
      },
    });
  }

  cadastrar(): void {
    this.mensagemErro = '';

    if (!this.nomeComando.trim()) {
      this.mensagemErro = 'Informe o nome do comando em lote.';
      return;
    }

    if (!this.comandoSelecionadoJson) {
      this.mensagemErro = 'Adicione um comando antes de cadastrar.';
      return;
    }

    const seriaisList = this.seriais
      .split(';')
      .map((serial) => serial.trim())
      .filter((serial) => serial.length > 0);

    if (this.envioPara === 'seriais' && seriaisList.length === 0) {
      this.mensagemErro = 'Informe ao menos um serial.';
      return;
    }

    if (this.envioPara === 'equipamento' && !this.equipamentoSelecionado) {
      this.mensagemErro = 'Selecione um equipamento.';
      return;
    }

    if (this.agendamentoTipo === 'especifico' && this.agendamentos.length === 0) {
      this.mensagemErro = 'Inclua ao menos um horário de agendamento.';
      return;
    }

    this.salvando = true;
    this.enviarCadastro(seriaisList);
  }

  // monta o payload com nome/tipoEnvio/seriais (aba "Seriais") ou equipamento/firmware (aba "Equipamento") e envia
  private enviarCadastro(seriaisList: string[]): void {
    const tipoEnvio: BatchCommandTargetType =
      this.envioPara === 'seriais' ? 'SERIAL' : 'EQUIPAMENTO';

    const payload: BatchCommandRequest = {
      nome: this.nomeComando.trim(),
      tipoEnvio,
      seriais: this.envioPara === 'seriais' ? seriaisList : undefined,
      equipamento:
        this.envioPara === 'equipamento'
          ? this.equipamentoSelecionado ?? undefined
          : undefined,
      firmware:
        this.envioPara === 'equipamento'
          ? this.firmwareSelecionado ?? undefined
          : undefined,
      comando: this.comandoSelecionadoJson ?? undefined,
      agendamentos:
        this.agendamentoTipo === 'especifico' ? this.agendamentos : undefined,
      userId: this.authService.currentUserValue?.userId,
    };

    this.commandsService.postBatchCommand(payload).subscribe({
      next: () => {
        this.salvando = false;
        this.toastService.show('Comando em lote cadastrado com sucesso!', {
          classname: 'bg-success text-center text-white',
          delay: 5000,
        });
        this.filtrar();
      },
      error: () => {
        this.salvando = false;
        this.toastService.show('Erro ao cadastrar o comando em lote.', {
          classname: 'bg-danger text-center text-white',
          delay: 5000,
        });
      },
    });
  }

  selecionarAgendamentoTipo(tipo: 'qualquerMomento' | 'especifico'): void {
    this.agendamentoTipo = tipo;
    this.erroAgendamento = '';
  }

  adicionarAgendamento(): void {
    this.erroAgendamento = '';

    if (!this.novoAgendamentoDia) {
      this.erroAgendamento = 'Selecione o dia da semana.';
      return;
    }

    if (!this.novoAgendamentoHoraInicio || !this.novoAgendamentoHoraFim) {
      this.erroAgendamento = 'Informe o horário inicial e final.';
      return;
    }

    if (this.novoAgendamentoHoraFim <= this.novoAgendamentoHoraInicio) {
      this.erroAgendamento = 'O horário final deve ser maior que o inicial.';
      return;
    }

    this.agendamentos.push({
      diaSemana: this.novoAgendamentoDia,
      horaInicio: this.novoAgendamentoHoraInicio,
      horaFim: this.novoAgendamentoHoraFim,
    });

    this.novoAgendamentoDia = null;
    this.novoAgendamentoHoraInicio = '';
    this.novoAgendamentoHoraFim = '';
  }

  removerAgendamento(index: number): void {
    this.agendamentos.splice(index, 1);
  }

  labelDiaSemana(dia: BatchCommandScheduleDay): string {
    return this.diasSemanaOptions.find((opcao) => opcao.value === dia)?.label ?? dia;
  }

  limparFormulario(): void {
    this.nomeComando = '';
    this.comandoSelecionadoNome = '';
    this.comandoSelecionadoJson = null;
    this.envioPara = 'seriais';
    this.seriais = '';
    this.equipamentoSelecionado = null;
    this.firmwareSelecionado = null;
    this.firmwares = [];
    this.agendamentoTipo = 'qualquerMomento';
    this.agendamentos = [];
    this.erroAgendamento = '';
    this.novoAgendamentoDia = null;
    this.novoAgendamentoHoraInicio = '';
    this.novoAgendamentoHoraFim = '';
    this.mensagemErro = '';
  }

  // monta o objeto de filtro a partir dos campos preenchidos na tela; retorna null quando o período está incompleto
  private montarFiltro(): BatchCommandFilter | null {
    this.filtroErro = '';

    const temDataInicial = !!this.filtroDataInicial;
    const temDataFinal = !!this.filtroDataFinal;

    if (temDataInicial !== temDataFinal) {
      this.filtroErro =
        'Preencha Data Inicial e Data Final para pesquisar por período.';
      return null;
    }

    return {
      dataInicial: temDataInicial
        ? new Date(`${this.filtroDataInicial}T00:00:00`).getTime()
        : undefined,
      dataFinal: temDataFinal
        ? new Date(`${this.filtroDataFinal}T23:59:59.999`).getTime()
        : undefined,
      idComando: this.filtroIdComando !== -1 ? this.filtroIdComando : undefined,
      status: this.filtroStatus || undefined,
      serial: this.filtroSerial.trim() || undefined,
      nome: this.filtroNome.trim() || undefined,
    };
  }

  filtrar(paginaAlvo: number = 1): void {
    const filter = this.montarFiltro();
    if (!filter) {
      return;
    }

    this.carregandoLista = true;
    this.commandsService
      .getBatchCommandsList(filter, paginaAlvo, this.tamanhoPagina)
      .subscribe({
        next: (data) => {
          this.batchCommands = data.items;
          this.paginaAtual = data.page;
          this.tamanhoPagina = data.size;
          this.totalRegistros = data.total;
          this.totalPaginas = Math.max(1, Math.ceil(data.total / data.size));
          this.temProximaPagina = data.hasNext;
          this.carregandoLista = false;
        },
        error: () => {
          this.batchCommands = [];
          this.totalRegistros = 0;
          this.totalPaginas = 0;
          this.temProximaPagina = false;
          this.carregandoLista = false;
        },
      });
  }

  exportandoCsv: boolean = false;

  exportarCsv(item: BatchCommandListItem): void {
    this.exportandoCsv = true;
    this.commandsService.exportBatchCommandsCsv(item.id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `comando-em-lote_${item.id}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.exportandoCsv = false;
      },
      error: () => {
        this.toastService.show('Erro ao exportar o CSV do comando em lote.', {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.exportandoCsv = false;
      },
    });
  }

  irParaPagina(pagina: number): void {
    if (
      pagina < 1 ||
      pagina > this.totalPaginas ||
      pagina === this.paginaAtual
    ) {
      return;
    }
    this.filtrar(pagina);
  }

  paginaAnterior(): void {
    this.irParaPagina(this.paginaAtual - 1);
  }

  proximaPagina(): void {
    this.irParaPagina(this.paginaAtual + 1);
  }

  podeCancelar(item: BatchCommandListItem): boolean {
    return this.statusPermitemCancelar.includes(item.status);
  }

  cancelarBatchCommand(item: BatchCommandListItem): void {
    if (!this.podeCancelar(item)) {
      return;
    }

    if (!confirm(`Tem certeza que deseja cancelar o comando em lote "${item.nome}"?`)) {
      return;
    }

    this.commandsService.cancelBatchCommand(item.id).subscribe({
      next: () => {
        this.filtrar(this.paginaAtual);
      },
      error: () => {
        this.filtroErro = 'Erro ao cancelar o comando em lote.';
      },
    });
  }

  abrirModalDetalhes(item: BatchCommandListItem, template: any): void {
    this.detalheSelecionado = item;
    this.detalheComando = null;
    this.erroDetalhe = '';
    this.paginaSeriais = 1;
    this.modalService.open(template, {
      centered: true,
      windowClass: 'modal-holder',
      size: 'xl',
    });
    this.carregarDetalheComando(item.id, this.paginaSeriais);
  }

  carregarDetalheComando(id: number, pagina: number): void {
    this.carregandoDetalhe = true;
    this.erroDetalhe = '';
    this.commandsService
      .getBatchCommandDetail(id, pagina, this.tamanhoPaginaSeriais)
      .subscribe({
        next: (data) => {
          this.detalheComando = data;
          this.paginaSeriais = data.page;
          this.tamanhoPaginaSeriais = data.size;
          this.totalPaginasSeriais = Math.max(1, Math.ceil(data.total / data.size));
          this.carregandoDetalhe = false;
        },
        error: () => {
          this.erroDetalhe = 'Erro ao carregar os detalhes do comando em lote.';
          this.carregandoDetalhe = false;
        },
      });
  }

  irParaPaginaSeriais(pagina: number): void {
    if (
      !this.detalheComando ||
      pagina < 1 ||
      pagina > this.totalPaginasSeriais ||
      pagina === this.paginaSeriais
    ) {
      return;
    }
    this.carregarDetalheComando(this.detalheComando.id, pagina);
  }

  paginaAnteriorSeriais(): void {
    this.irParaPaginaSeriais(this.paginaSeriais - 1);
  }

  proximaPaginaSeriais(): void {
    this.irParaPaginaSeriais(this.paginaSeriais + 1);
  }
}


